import React, { useState, useEffect, useCallback } from "react"; 
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FaArrowLeft,
  FaMapMarkerAlt,
  FaClock,
  FaUser,
  FaTag,
  FaCheckCircle,
  FaEdit,
  FaSave
} from "react-icons/fa";

import api from "../services/api";
import { useAuth } from "../context/AuthContext";
import "./SuggestionDetail.css";

const SuggestionDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
 const { corporator } = useAuth();

const isCorporator =
  corporator?.role === "ROLE_CORPORATOR" ||
  corporator?.role === "CORPORATOR";

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [suggestion, setSuggestion] = useState(null);

  const [status, setStatus] = useState("");

  const [remarks, setRemarks] = useState("");

 const fetchSuggestion = useCallback(async () => {
  try {
    setLoading(true);

    const res = await api.get(`/api/suggestions/${id}`);

    const data =
      res.data.data ||
      res.data.suggestion ||
      res.data;

    setSuggestion(data);
    setStatus(data.status || "SUBMITTED");
    setRemarks(data.corporatorRemarks || "");
  } catch (err) {
    console.error(err);
    toast.error("Failed to load suggestion");
    navigate("/dashboard");
  } finally {
    setLoading(false);
  }
}, [id, navigate]);

useEffect(() => {
  fetchSuggestion();
}, [fetchSuggestion]);
  const saveChanges = async () => {
    try {
      setSaving(true);

      await api.put(
    `/api/suggestions/${id}/status`,
    null,
    {
        params: {
            status
        }
    }
);

     await api.put(
    `/api/suggestions/${id}/remarks`,
    null,
    {
        params: {
            remarks
        }
    }
);
      toast.success("Suggestion updated");

      fetchSuggestion();
    } catch (err) {
      console.error(err);
      toast.error("Unable to update suggestion");
    } finally {
      setSaving(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  const getBadge = (value) => {
    if (!value)
      return (
        <span className="status-badge submitted">
          SUBMITTED
        </span>
      );

    return (
      <span
        className={`status-badge ${value.toLowerCase()}`}
      >
        {value.replace("_", " ")}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="suggestion-loading">
        Loading suggestion...
      </div>
    );
  }

  if (!suggestion) {
    return (
      <div className="suggestion-loading">
        Suggestion not found.
      </div>
    );
  }

  return (
  <div className="suggestion-page">
    <div className="suggestion-container">

      <button
        className="suggestion-detail-back-btn"
        onClick={() => navigate("/dashboard")}
      >
        <FaArrowLeft /> Back to Dashboard
      </button>

      <div className="suggestion-header">
        <div>
          <h2>{suggestion.title}</h2>

          <div className="suggestion-meta">
            {getBadge(suggestion.status)}
          </div>
        </div>
      </div>

      <div className="suggestion-card">

        <div className="info-row">
          <FaTag className="info-icon" />
          <div>
            <label>Category</label>
            <p>{suggestion.category}</p>
          </div>
        </div>

        <div className="info-row">
          <FaMapMarkerAlt className="info-icon" />
          <div>
            <label>Location</label>
            <p>{suggestion.location}</p>
          </div>
        </div>

        <div className="info-row">
          <FaClock className="info-icon" />
          <div>
            <label>Submitted On</label>
            <p>{formatDate(suggestion.createdAt)}</p>
          </div>
        </div>

        {suggestion.userName && (
          <div className="info-row">
            <FaUser className="info-icon" />
            <div>
              <label>Citizen</label>
              <p>{suggestion.userName}</p>
            </div>
          </div>
        )}

        <div className="description-box">
          <label>Description</label>

          <p>{suggestion.description}</p>
        </div>

        {!isCorporator && (
          <>
            <div className="remarks-box">
              <label>Corporator Remarks</label>

              <p>
                {suggestion.corporatorRemarks ||
                  "No remarks available yet."}
              </p>
            </div>

            <div className="readonly-status">
              <FaCheckCircle />

              Current Status :
              {getBadge(suggestion.status)}
            </div>
          </>
        )}

        {isCorporator && (
          <>
            <div className="edit-section">

              <label>
                <FaEdit /> Update Status
              </label>

              <select
                value={status}
                onChange={(e) =>
                  setStatus(e.target.value)
                }
              >
                <option value="SUBMITTED">
                  Submitted
                </option>

                <option value="UNDER_REVIEW">
                  Under Review
                </option>

                <option value="IMPLEMENTED">
                  Implemented
                </option>

                <option value="REJECTED">
                  Rejected
                </option>
              </select>

              <label>
                Corporator Remarks
              </label>

              <textarea
                rows={5}
                value={remarks}
                placeholder="Enter remarks..."
                onChange={(e) =>
                  setRemarks(e.target.value)
                }
              />

              <button
                className="save-btn"
                disabled={saving}
                onClick={saveChanges}
              >
                <FaSave />

                {saving
                  ? "Saving..."
                  : "Save Changes"}
              </button>

            </div>
          </>
        )}

      </div>

    </div>
  </div>
);

};

export default SuggestionDetail;